import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

import { Children, Element } from 'interfaces';

import Title from 'components/ui/Title';

import {
  ArrowLinkWrapper
} from './ArrowLink.styles';

export interface ArrowLinkProps {
  children: Children;
  to: string;
  className?: string;
  size?: 'big' | 'normal' | 'small';
  color?: 'black' | 'white' | 'primary' | 'secondary' | 'trinary';
  noMargin?: boolean;
  linkBorder?: number;
  linkColor?: string;
  element?: Element;
  target?: '_blank' | '_self' | '_parent' | '_top';
}

const ArrowLink = ({
  children,
  to,
  size = 'normal',
  color = 'primary',
  linkBorder = 2,
  linkColor = '',
  className = '',
  noMargin = false,
  element = 'h1',
  target = '_self'
}: ArrowLinkProps) => {
  return (
    <Title element={element} size={size} color={color} noMargin={noMargin} className={className}>
      <ArrowLinkWrapper to={to} target={target} border={linkBorder} color={linkColor}>
        <span>{children}</span>
        <FaArrowRight />
      </ArrowLinkWrapper>
    </Title>
  );
};

export default ArrowLink;
